export const PermissionTypes = {
  PAGE_SETUP: {
    id: 1,
    title: 'Setup',
    root: 'setup',
  },
  DEPOSITS: {
    id: 2,
    title: 'Deposits',
    root: 'bookings',
  },
  ORDER_AND_PAY: {
    id: 3,
    title: 'Order & Pay',
    root: 'live',
  },
  COMPLETED_ORDERS: {
    id: 4,
    title: 'Completed',
    root: 'completed',
  },
  MENUS: {
    id: 5,
    title: 'Menus',
    root: 'menus',
  },
  STATS: {
    id: 6,
    title: 'Stats',
    root: 'sales',
  },
  FINANCES: {
    id: 7,
    title: 'Finances',
    root: 'financial',
  },
  USER_MANAGEMENT: {
    id: 8,
    title: 'Users',
    root: 'users',
  },
  CREATE_VENUE: {
    id: 9,
    title: 'Create Venue',
    root: 'create-venue',
  },
};



// WEBPACK FOOTER //
// ./src/utils/constants/permissions.js